module.exports = __webpack_public_path__ + "static/assets/25d9035005e6a4833dbb463da19ec139.gif";